<template>
  <div class="no-gutters-md hotels-messages row">
    <div class="hotels-messages__no-availability bg-color-light-purple col" >

      <div class="icon_info_message">
        <i v-if="icon" class="color-black md" :class="icon"></i>
      </div>

      <div class="hotels-messages__body ">
        <p v-if="title" class="text-14 mb-0 font-bold hotels-messages__title color-black text-left" v-html="title"></p>
        <p v-if="description" class="text-14 font-bold mb-0 hotels-messages__title color-black text-left" v-html="description"></p>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'InfoMessage',
  props: {
    title: String,
    description: String,
    icon: String
  }
}
</script>

<style scoped lang="scss">
.hotels-messages {
  &__no-availability {
    padding: 2rem;
    display: flex;
    align-items: flex-start;
  }
  &__body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 2rem;
  }

  &__title {
    line-height: 20px;
  }

  i[class*="icon-"] {
    &.color-black {
      color: black;
    }
  }
}
.icon_info_message{
  padding-top: 1rem;
  margin-bottom: -1rem;
}

@media screen and (min-width: 991px) {
  .card-lite {
    flex-direction: row;
  }
}

</style>
